export default __webpack_public_path__ + "static/media/Design_FactcheckerS3.823271d0.png";